module.exports = new __parcel__URL__("raid_history_text.64b2d76a.png").toString();